const local = window.location.hostname == 'localhost' || window.location.hostname.substr(0, 7) == "192.168";
const debug = local && window.location.port == "8081";

export default {
  local,
  debug,
};
